// @flow
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Container from './container'
import Icon from './icon'
import styles from './footer.module.css'

function Footer() {
  const data = useStaticQuery(graphql`
    query Footer {
      site {
        siteMetadata {
          socialLinks {
            id
            name
            url
          }
        }
      }
    }
  `)
  const { socialLinks } = data.site.siteMetadata
  return (
    <div className={styles.wrapper}>
      <Container>
        <ul className={styles.list}>
          {socialLinks.map((link) => (
            <li key={link.id} className={styles.item}>
              <a href={link.url} className={styles.link}>
                <Icon role="img" id={link.id} title={link.name} />
              </a>
            </li>
          ))}
        </ul>
      </Container>
    </div>
  )
}

export default Footer
